import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import theme from './theme'
import './Global.Styled'
import Home from './components/Home/Home'
import Kandi from './components/Kandi/Kandi'
import NewsAlarm from './components/Topic/NewsAlarm/NewsAlarm'
import ProgramPage from './components/Topic/Program/ProgramPage'

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            {/* home */}
            <Route index element={<Home />} />

            {/* kandi */}
            <Route path="wk/:wahlkreisID" element={<Kandi />} />

            {/* topic */}
            <Route path="newsalarm" element={<NewsAlarm />} />
            <Route path="programm" element={<ProgramPage />} />

            {/* fallback routing */}
            <Route path={'*'} element={<Navigate replace to="/" />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </div>
  )
}

export default App
